import { render, staticRenderFns } from "./invadobay-previews.vue?vue&type=template&id=1195f442&scoped=true"
import script from "./invadobay-previews.vue?vue&type=script&lang=js"
export * from "./invadobay-previews.vue?vue&type=script&lang=js"
import style0 from "./invadobay-previews.vue?vue&type=style&index=0&id=1195f442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1195f442",
  null
  
)

export default component.exports